import React, { useEffect, useRef } from "react"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"
import ProjectPreview from "./project-preview"
import { graphql, useStaticQuery } from "gatsby"
import "../sass/carousel.scss"

const MultiCarousel = props => {
  const data = useStaticQuery(graphql`
    {
      allProjectsJson {
        edges {
          node {
            id
            slug
            title
            image {
              childImageSharp {
                fluid(maxWidth: 800) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  `)
  const projects = data.allProjectsJson.edges
  const carouselRef = useRef()

  useEffect(() => {
    const idx = projects.findIndex(e => e.node.id.toString() === props.slide)

    if (carouselRef && carouselRef.current) {
      carouselRef.current.goToSlide(
        //carouselRef.current.state.currentSlide + idx
        idx
      )
    }
  })

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
  }

  return (
    <nav className="slider-wrapper">
      <Carousel
        ref={carouselRef}
        focusOnSelect={true}
        swipeable={true}
        draggable={true}
        showDots={false}
        responsive={responsive}
        ssr={false} // means to render carousel on server-side.
        infinite={false}
        autoPlay={true}
        /* autoPlay={this.props.deviceType !== "mobile" ? true : false} */
        autoPlaySpeed={2000}
        keyBoardControl={true}
        customTransition="transform 1000ms ease-in-out"
        transitionDuration={1000}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["desktop", "tablet", "mobile"]}
        //deviceType={this.props.deviceType}
        minimumTouchDrag={80}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
        afterChange={(p, { currentSlide }) => {
          if (carouselRef.current != null) {
            if (
              currentSlide ===
              projects.length - carouselRef.current.state.slidesToShow
            ) {
              setTimeout(() => {
                //console.log(carouselRef)
                carouselRef.current.goToSlide(0)
              }, carouselRef.current.props.autoPlaySpeed)
            }
          }
        }}
      >
        {projects.map(({ node: project }) => {
          const id = project.id
          const slug = project.slug
          const title = project.title
          const imageData = project.image.childImageSharp.fluid
          return (
            <ProjectPreview
              key={id}
              slug={slug}
              title={title}
              imageData={imageData}
            />
          )
        })}
      </Carousel>
    </nav>
  )
}

export default MultiCarousel
